import { z } from "zod";

import { railLayoutSchema } from "../rail-branches";
import { characterSchema } from "./character";
import { placeSchema } from "./place";
import { sceneSchema } from "./scene";

export const journeyModeSchema = z.enum(["book", "universe"]);

export const timelineEventSchema = z.object({
  eventId: z.string().min(1),
  sceneId: z.string().min(1),
  playbackMs: z.number().int().nonnegative(),
  durationMs: z.number().int().positive(),
  characterIds: z.array(z.string()).min(1),
  locationLabel: z.string().min(1),
  /** Root place, then the part inside it, when the draft named a parent. */
  locationPath: z.array(z.string().min(1)).min(1).optional(),
  title: z.string().min(1),
  /** Dense 1..N rank on a book-level universe compile. */
  universeRank: z.number().int().positive().optional(),
});

export const timeMarkSchema = z.object({
  startMs: z.number().int().nonnegative(),
  label: z.string().min(1),
});

export const compiledChapterSchema = z.object({
  bookId: z.string().min(1),
  chapterId: z.string().min(1),
  title: z.string().min(1),
  /** Present on a joined book so overlay copy can name each chapter. */
  chapterTitles: z.array(z.object({
    chapterId: z.string().min(1),
    title: z.string().min(1),
  })).optional(),
  characters: z.array(characterSchema),
  places: z.array(placeSchema).default([]),
  scenes: z.array(sceneSchema),
  eventsByJourney: z.object({
    book: z.array(timelineEventSchema),
    universe: z.array(timelineEventSchema),
  }),
  /** Where people stay, and where the white line forks. One layout per journey. */
  railsByJourney: z.object({
    book: railLayoutSchema,
    universe: railLayoutSchema,
  }),
  /** Universe-view labels at story-time jumps. */
  timeMarks: z.array(timeMarkSchema).optional(),
});

export type JourneyMode = z.infer<typeof journeyModeSchema>;
export type TimelineEvent = z.infer<typeof timelineEventSchema>;
export type CompiledChapter = z.infer<typeof compiledChapterSchema>;
export type TimeMark = z.infer<typeof timeMarkSchema>;
